import { useEffect, useState } from 'react';
import './App.css';
import CountryBoard from './components/CountryBoard';
import WorldMap from './components/WorldMap';
import { countries as ALL_COUNTRIES, continents } from './data';

export default function App() {
  const [loading, setLoading] = useState(true);
  const [activeContinent, setActiveContinent] = useState(null);
  const [hoveredId, setHoveredId] = useState(null);

  useEffect(() => {
    const src = process.env.PUBLIC_URL + '/map.svg';
    const img = new Image();
    img.src = src;

    const done = () => setLoading(false);

    if (img.decode) {
      img.decode().then(done).catch(done);
    } else {
      img.onload = done;
      img.onerror = done;
    }
  }, []);

  if (loading) {
    return (
      <div className="loader-wrap">
        <div className="loader" />
      </div>
    );
  }

  const filtered = !activeContinent
    ? ALL_COUNTRIES
    : ALL_COUNTRIES.filter((c) => c.continent === activeContinent);

  return (
    <div>
      <h1 style={{ textAlign: 'center', marginTop: 20 }}>Country Guides</h1>

      <WorldMap
        countries={filtered}
        hoveredId={hoveredId}
        setHoveredId={setHoveredId}
      />

      <CountryBoard
        allContinents={continents}
        activeContinent={activeContinent}
        setActiveContinent={setActiveContinent}
        countries={filtered}
        hoveredId={hoveredId}
        setHoveredId={setHoveredId}
      />
    </div>
  );
}
